module.exports = __webpack_public_path__ + "40c6ef0f8cccc2d543423f51be327355.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Help/screenshots/Wizard Page (7).png
// module id = 1050
// module chunks = 0